import React from "react";
import { Switch, Route } from "react-router-dom";
import Unsubscribe from "./Unsubscribe.js";

import config from "config.js";

function Public(){
    return (
        <Switch>
            <Route path={config.MYACCOUNT.APP_PATH + "/public/unsubscribe"}><Unsubscribe /></Route>
            <Route><p>404 Not Found</p></Route>
        </Switch>
    );
}

export default Public;
